module.exports = __webpack_public_path__ + "static/media/math-arena-logo-red.c614bf9a.svg";